export class Sort {
    field : string;
    dir : 'asc' | 'desc';

    constructor(field : string, dir : 'asc' | 'desc'){
        this.field = field;
        this.dir = dir;
    }
}
